/**
 * Склонение существительных после числа.
 *
 * «1 минут» вместо «1 минуты» в интерфейсе выглядит как недоделка,
 * а такие места разбросаны по всему продукту: единицы, сцены, секунды.
 */
export function plural(count: number, forms: [string, string, string]): string {
  const abs = Math.abs(count) % 100;
  const last = abs % 10;

  if (abs > 10 && abs < 20) return forms[2];
  if (last > 1 && last < 5) return forms[1];
  if (last === 1) return forms[0];
  return forms[2];
}

/** Число вместе со склонённым словом: `withPlural(2, ['минута','минуты','минут'])`. */
export const withPlural = (count: number, forms: [string, string, string]): string =>
  `${count.toLocaleString('ru-RU')} ${plural(count, forms)}`;

export const pluralForms = {
  minute: ['минута', 'минуты', 'минут'] as [string, string, string],
  second: ['секунда', 'секунды', 'секунд'] as [string, string, string],
  unit: ['единица', 'единицы', 'единиц'] as [string, string, string],
  scene: ['сцена', 'сцены', 'сцен'] as [string, string, string],
  file: ['файл', 'файла', 'файлов'] as [string, string, string],
} as const;
